export const reducirHash = ({hash, largo = 7}) => {

    return hash.substring(hash.length, hash.length - largo);

}